import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { isPermitted } from "util/PermissionsMixin";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import useCurrentUser from "hooks/useCurrentUser";
import useMigrationState from "./useMigrationState";
const fetchShowDatanodeMigration = async () => fetch("GET", qualifyUrl("/datanode/configured"));
const useShowDatanodeMigration = () => {
  const { permissions } = useCurrentUser();
  const canStartDataNode = useMemo(() => isPermitted(permissions, "datanode:start"), [permissions]);
  const { data: isDatanodeConfiguredAndUsed } = useQuery({
    queryKey: ["show_datanode_migration"],
    queryFn: fetchShowDatanodeMigration,
    enabled: canStartDataNode
  });
  const { currentStep } = useMigrationState({ enabled: canStartDataNode });
  const noMigrationInProgress = !currentStep || (currentStep == null ? void 0 : currentStep.state) === "NEW" || (currentStep == null ? void 0 : currentStep.state) === "FINISHED";
  return {
    isDatanodeConfiguredAndUsed: canStartDataNode && !!isDatanodeConfiguredAndUsed,
    showDatanodeMigration: canStartDataNode && (!isDatanodeConfiguredAndUsed || !noMigrationInProgress)
  };
};
export default useShowDatanodeMigration;
